
















































import { ICoast } from "@/@types/_shared/coast";
import { IUser } from "@/@types/admin/user/user";
import { IOrder } from "@/@types/orders/new-order";
import { getTime } from "@/services/dateTime/getFullDate";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class OrderCard extends Vue {
  @Prop({ type: Object, default: null }) order!: IOrder;
  @Prop({ type: Array, default: () => [] }) managers!: Array<IUser>;

  get orderCoast(): string {
    let coast: { [x: string]: number } = {};

    this.order.cart.forEach((item) => {
      const coasts = Object.keys(coast);
      const itemcoast: ICoast = this.$getCoast(item.params.coast);
      if (!itemcoast) return;
      if (coasts.includes(itemcoast.currency))
        coast[itemcoast.currency] += item.count * itemcoast.value;
      else coast[itemcoast.currency] = item.count * itemcoast.value;
    });

    let result = "";
    Object.keys(coast).forEach((cost) => (result += `${coast[cost]} ${cost}`));
    return result;
  }

  get manager(): IUser | null {
    const waiter = this.managers.find((w) => w._id === this.order.manager_id);
    return waiter ? waiter : null;
  }

  get date_create_order(): string {
    return getTime(this.order.date_create_order);
  }

  get date_closed_order(): string {
    return getTime(this.order.date_closed_order);
  }
}
